import { HomepageHeroSlider } from '../../../../defaultTheme/js/src/__utils/sliders';

jQuery(document).ready(function () {
	jQuery('.block-homepage-hero .dots-slider').slick({
		arrows: false,
		fade: true,
		autoplay: true,
		speed: 2000,
	});
	HomepageHeroSlider.init();
}, 100);
